import React, { FC } from "react";
import { DotLottie, DotLottieReact, FrameEvent } from "@lottiefiles/dotlottie-react";
import loadingDots from "@/assets/lottie/loading-dots.lottie?url";
import { Flex, Box, Text } from "@chakra-ui/react";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import IconTileContentLayout from "@/js/components/StudentTile/components/IconTileContentLayout";
import { useTranslation } from "react-i18next";

const StudentTileConnecting: FC = () => {
	const { t } = useTranslation();
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	const dotLottieRefCallback = (dotLottie: DotLottie) => {
		// when the student tile animation loads in, the animation causes some weird sizing issues
		// with the lottie animation, manually resize every 15 frames (best results after some trial and error)
		if (dotLottie) {
			dotLottie.addEventListener("frame", (n: FrameEvent) => {
				if (Math.floor(n.currentFrame % 15) === 0) {
					dotLottie.resize();
				}
			});
		}
	};

	return (
		<Flex flexDirection="column" align="center" height={tileSize !== "sm" ? "100%" : undefined}>
			{/* Keep lottie inside IconTileContentLayout (same pattern as StudentReconnecting). A sibling with height="100%"
			    fights the lottie for vertical space and leaves an empty strip at the bottom of the tile. */}
			<IconTileContentLayout>
				<Box w="54px" h="54px" display="flex" alignItems="center" justifyContent="center" flexShrink={0}>
					<DotLottieReact
						src={loadingDots}
						loop
						style={{ width: "46px", height: "46px" }}
						autoplay
						renderConfig={{ autoResize: true, freezeOnOffscreen: false }}
						dotLottieRefCallback={dotLottieRefCallback}
					/>
				</Box>
				<Text fontWeight="bold" lineHeight={1.3}>
					{t("studentTile.connectingTitle")}
				</Text>
				{tileSize !== "sm" && <Text>{t("studentTile.connectingSubtitle")}</Text>}
			</IconTileContentLayout>
		</Flex>
	);
};

export default StudentTileConnecting;
